<template>
  <tr
    v-if="!editing"
    class="bg-white"
  >
    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
      {{ contact.name }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      {{ contact.position }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      <a :href="'mailto:' + contact.email">{{ contact.email }}</a>
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      <a :href="'tel:' + contact.phone">{{ contact.phone }}</a>
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
      <span
        v-if="recentlySuccessful"
        class="text-green-600"
      >Saved</span>
      <button
        v-else
        type="button"
        class="bg-white rounded-md font-medium text-purple-600 hover:text-purple-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
        @click="open"
      >
        Update
      </button>
    </td>
  </tr>

  <tr
    v-else
    class="bg-white"
  >
    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
      <input
        id="name"
        v-model="form.name"
        type="text"
        name="name"
        class="max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md p-1"
        :class="{'border-red-300': form.errors.name }"
      >
      <p
        v-if="form.errors.name"
        class="absolute mt-1 text-xs text-red-600"
      >
        {{ form.errors.name }}
      </p>
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      <input
        id="position"
        v-model="form.position"
        type="text"
        name="position"
        class="max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md p-1"
        :class="{'border-red-300': form.errors.position }"
      >
      <p
        v-if="form.errors.position"
        class="absolute mt-1 text-xs text-red-600"
      >
        {{ form.errors.position }}
      </p>
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      <input
        id="email"
        v-model="form.email"
        type="text"
        name="email"
        class="max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md p-1"
        :class="{'border-red-300': form.errors.email }"
      >
      <p
        v-if="form.errors.email"
        class="absolute mt-1 text-xs text-red-600"
      >
        {{ form.errors.email }}
      </p>
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      <input
        id="phone"
        v-model="form.phone"
        type="text"
        name="phone"
        class="max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md p-1"
        :class="{'border-red-300': form.errors.phone }"
      >
      <p
        v-if="form.errors.phone"
        class="absolute mt-1 text-xs text-red-600"
      >
        {{ form.errors.phone }}
      </p>
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium flex justify-end space-x-1">
      <button
        :class="{ 'opacity-25': form.processing }"
        :disabled="form.processing"
        type="button"
        class="inline-flex justify-center px-2 py-1 border border-green-200 shadow-sm text-xs font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
        @click="save"
      >
        <svg
          class="-mx-1 h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </button>
      <button
        type="button"
        class="inline-flex justify-center px-2 py-1 border border-yellow-200 shadow-sm text-xs font-medium rounded-md text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
        @click="cancel"
      >
        <svg
          class="-mx-1 h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <button
        type="button"
        class="inline-flex justify-center px-2 py-1 border border-red-200 shadow-sm text-xs font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
        @click="cancel"
      >
        Delete
      </button>
    </td>
  </tr>
</template>

<script>

export default {
  props: [
    'contact',
  ],

  emits: ['submitted'],
  data() {
    return {
      editing: false,
      initial_value: null,
      saved: false,
      form: this.$inertia.form({
        name: this.contact.name,
        position: this.contact.position,
        email: this.contact.email,
        phone: this.contact.phone,
      }),
    };
  },
  computed: {
    recentlySuccessful() {
      return this.saved && this.form.recentlySuccessful;
    },
  },
  watch: {
    recentlySuccessful(val, oldVal) {
      if (val === true) {
        this.editing = false;
      }
    },
  },
  methods: {
    cancel() {
      this.form.name = this.contact.name;
      this.form.position = this.contact.position;
      this.form.email = this.contact.email;
      this.form.phone = this.contact.phone;
      this.form.clearErrors();
      this.saved = false;
      this.editing = false;
    },
    open() {
      this.saved = false;
      this.editing = true;
    },
    save() {
      this.saved = true;
      this.form.put(route('contacts.update', { contact: this.contact.id }), {
        errorBag: 'updateContact',
        preserveScroll: true,
      });
      this.$emit('submitted');
    },
  },
};
</script>
